import { TmcContextService } from './../../../../tmc-context.service';
import { StationType } from './../../../../../client/model/station-type.enum';
import { StationSet } from './../../../../../client/model/station-set';
import { Station } from './../../../../../client/model/station';
import { StationGroup } from './../../../../../client/model/station-group';
import { YardConfiguration } from '../../../../../client/model/yard-configuration';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { MasterDetailListEntry } from '@sdbn/common';
import { StructureSelctionFilter, StructureSelection, StructureSelectionRequest, StructureSelectionScope } from '../../../structure-selection.model';

@Component({
  selector: 'app-structure-selection',
  templateUrl: './structure-selection.component.html',
  styleUrls: ['./structure-selection.component.scss']
})
export class StructureSelectionComponent implements OnDestroy {


  StructureSelectionScope = StructureSelectionScope;
  StructureSelctionFilter = StructureSelctionFilter;
  StationType = StationType;

  stationGroups: Array<StationGroup>;

  selectedStationGroup: StationGroup = null;

  selectedStationSet: StationSet;

  selectedStation: Station;

  yardConfiguration: YardConfiguration;

  request: StructureSelectionRequest;

  @Input('request') set setRequest(value: StructureSelectionRequest) {

    this.request = value;
    console.log('initializing with request', this.request);

    // daten ermitteln da sich Einstellungen geändert haben könnten
    this.initialzeStationGroups();


    if (value?.selection?.stationGroupId) {
      this.selectedStationGroup = this.yardConfiguration.getStationGroupById(value?.selection?.stationGroupId);
    }
    if (value?.selection?.stationSetId) {
      this.selectedStationSet = this.yardConfiguration.getStationSetById(value?.selection?.stationSetId);
    }
    if (value?.selection?.stationId) {
      this.selectedStation = this.yardConfiguration.getStationById(value?.selection?.stationId);
    }
    this.notifySelection();
  }

  @Output() selectionChanged = new EventEmitter<StructureSelection>();

  constructor(
    private tmcContextService: TmcContextService
  ) {
    this.tmcContextService.updated.subscribe(
      yardConfiguration => {
        this.yardConfiguration = yardConfiguration;
        this.initialzeStationGroups();
      }
    );
  }

  private notifySelection() {
    this.selectionChanged.next(new StructureSelection({
      stationGroupId: this.selectedStationGroup?.id,
      stationSetId: this.selectedStationSet?.id,
      stationId: this.selectedStation?.id,
      valid: this.validateSelection()
    }));
  }

  private initialzeStationGroups() {
    if (this.yardConfiguration != null) {

      if (this.request?.fixedStationSetId != null) {
        this.stationGroups = this.yardConfiguration.stationGroups.filter(sg => {
          for (let stationSet of sg.stationSets) {
            if (stationSet.id === this.request.fixedStationSetId) {
              return true;
            }
          }
          return false;
        });
      } else {
        this.stationGroups = this.yardConfiguration.stationGroups;
      }

      if (this.stationGroups.length > 0 && this.selectedStationGroup == null && this.selectedStationSet == null && this.selectedStation == null) {
        this.selectedStationGroup = this.stationGroups[0];
        this.notifySelection();
      }
    }
  }

  private validateSelection(): boolean {
    let valid = true;
    // if (this.selection.fixedStationSetId != null && this.selection.fixedStationSetId !== this.selection.stationSetId) {
    //   valid = false
    // } else {
    if (this.request?.scope === StructureSelectionScope.ANY) {
      valid = this.selectedStation != null || this.selectedStationSet != null || this.selectedStationGroup != null;
    } else if (this.request?.scope === StructureSelectionScope.STATION) {
      valid = this.selectedStation != null && this.selectedStationSet != null && this.selectedStationGroup != null;
    } else if (this.request?.scope === StructureSelectionScope.STATION_SET) {
      valid = this.selectedStation == null && this.selectedStationSet != null && this.selectedStationGroup != null;
    } else if (this.request?.scope === StructureSelectionScope.STATION_OR_STATION_SET) {
      valid = this.selectedStationSet != null && this.selectedStationGroup != null;
    } else if (this.request?.scope === StructureSelectionScope.STATION_SET_OR_STATION_GROUP) {
      valid = this.selectedStation == null && this.selectedStationGroup != null;
    }
    // }

    // this.validation$.next(valid);
    return valid;
  }

  ngOnDestroy(): void {

  }

  selectStation(stationSet: StationSet, station: Station) {

    if ((this.request?.scope === StructureSelectionScope.ANY ||
      this.request?.scope === StructureSelectionScope.STATION_OR_STATION_SET ||
      this.request?.scope === StructureSelectionScope.STATION)
      &&
      ((this.request?.filter === StructureSelctionFilter.ANY) ||
        (station.stationType === StationType.WORKING_AREA && this.request?.filter == StructureSelctionFilter.STATION) ||
        (station.stationType === StationType.WAITING_AREA && this.request?.filter == StructureSelctionFilter.WAITING_AREA))
    ) {

      if (this.selectedStationSet === stationSet &&
        this.selectedStation == station) {
        this.selectedStationSet = null;
        this.selectedStation = null;
        this.notifySelection();
      } else {
        this.selectedStationSet = stationSet;
        this.selectedStation = station;
        this.notifySelection();
      }

    }
  }

  selectStationSet(stationSet: StationSet) {
    if (this.request?.scope === StructureSelectionScope.ANY ||
      this.request?.scope === StructureSelectionScope.STATION_OR_STATION_SET ||
      this.request?.scope === StructureSelectionScope.STATION_SET ||
      this.request?.scope === StructureSelectionScope.STATION_SET_OR_STATION_GROUP) {

      if (this.selectedStationSet === stationSet &&
        this.selectedStation == null) {
        this.selectedStationSet = null;
        this.notifySelection();
      } else {
        this.selectedStationSet = stationSet;
        this.selectedStation = null;
        this.notifySelection();
      }

    }
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    if (this.selectedStationGroup !== entry as StationGroup) {
      this.selectedStationGroup = entry as StationGroup;
      this.selectedStationSet = null;
      this.selectedStation = null;
      this.notifySelection();
    }
  }

}
